import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Button, FormControl, FormControlLabel, MenuItem, Radio, RadioGroup, Select, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import Page from '../../component/Page'
import api from '../../api/api'
import { SETTING_CONFIG } from './config.'
import Swal from 'sweetalert2'
import RequireSelect from '../../component/RequireSelect'
import dayjs from 'dayjs'
import RequireField from '../../component/RequireField'

export default function ViewItem() {
    const breedClass = [
        {
            value: 'หลัก'
        },
        {
            value: 'ขยาย'
        },
        {
            value: 'จำหน่าย'
        }
    ]

    const seasons = [
        {
            value: 'แล้ง'
        },
        {
            value: 'ฝน'
        }
    ]
    const navigate = useNavigate();

    const { id } = useParams()
    const [detail, setDetail] = useState()
    const [CatalogNo, setCatalogNo] = useState()
    const [dataItemCatalogs, setDataItemCatalogs] = useState([])
    const [GroupNo, setGroupNo] = useState()
    const [dataItemGroups, setDataItemGroups] = useState([])
    const [TypeNo, setTypeNo] = useState()
    const [seasonsNo, setSeasonsNo] = useState()
    const [breedClassNo, setBreedClassNo] = useState()
    const [dataItemTypes, setDataItemTypes] = useState([])
    const [Barcode, setBarcode] = useState('')
    const [SalePrice, setSalePrice] = useState('')
    const [Description, setDescription] = useState('')
    const [Status, setStatus] = useState('Y')
    const [Chemical, setChemical] = useState('')
    const [GroupError, setGroupError] = useState(false)
    const [CatalogError, setCatalogError] = useState(false)
    const [breedClassError, setBreedClassError] = useState(false)
    const [TypeNoError, setTypeNoError] = useState(false)
    const [seasonsError, setSeasonsError] = useState(false)
    const [SalePriceError, setSalePriceError] = useState(false)

    const getItemCatalogs = async () => {
        const res = await api.get(`dbms/itemcatalogs`)
        const data = await res.data.result
        if (res.data.status === true) {
            setDataItemCatalogs(data)
        }
    }
    const getItemGroups = async () => {
        const res = await api.get(`dbms/itemgroups`)
        const data = await res.data.result
        if (res.data.status === true) {
            setDataItemGroups(data)
        }
    }

    const getItemTypes = async () => {
        const res = await api.get(`dbms/itemtypes`)
        const data = await res.data.result
        if (res.data.status === true) {
            setDataItemTypes(data)
        }
    }
    const getItemMasterInfo = async () => {

        const url = SETTING_CONFIG.requests.getItemMasters.url + `/${id}`;
        const res = await api.get(url)
        const data = res.data
        if (data.status === true) {
            setDetail(data.result)
            setBarcode(data.result.Barcode)
            setCatalogNo(data.result.CatalogNo.CatalogNo)
            setGroupNo(data.result.GroupNo.GroupNo)
            setTypeNo(data.result.Option1)
            setBreedClassNo(data.result.Option2)
            setChemical(data.result.Chemical)
            setSeasonsNo(data.result.Season)
            setSalePrice(data.result.SalePrice)
            setDescription(data.result.Description)
            setStatus(data.result.Status)
        }
    }
    useEffect(() => {
        getItemCatalogs()
        getItemGroups()
        getItemTypes()
        if (id) {
            getItemMasterInfo()
        }
    }, [])
    const handleSubmit = async () => {
        const _gNo = GroupNo;
        const _cNo = CatalogNo;
        const cateSelect = dataItemCatalogs.find(x => x.CatalogNo === _cNo);
        const groupSelect = dataItemGroups.find(x => x.GroupNo === _gNo);
        const itemName = `${groupSelect?.GroupName} ${cateSelect?.CatalogName}`
        const body = {
            ItemId: detail ? detail?.ItemId : undefined,
            ItemNo: detail ? id : null,
            ItemName: itemName,
            Barcode: Barcode,
            Description: Description,
            Chemical: Chemical,
            Season: seasonsNo,
            Option1: TypeNo,
            Option2: breedClassNo,
            SalePrice: SalePrice,
            LotControl: undefined,
            Status: Status,
            GroupNo: GroupNo,
            CatalogNo: CatalogNo,
            UnitNo: 'K'
        }
        const itemMasterAdd = async () => {


            if (body?.ItemId) {
                // const url = SETTING_CONFIG.requests.getItemMasters.url + `/${body?.ItemNo}`;
                const url = SETTING_CONFIG.requests.getBranchs.url + `/${body?.BranchNo}/items/${body?.ItemNo}`;
                const res = await api.put(url, body)
                const data = res.data
                if (data.status === true) {
                    Swal.fire(
                        'ทำรายการสำเร็จ',
                        '',
                        'success'
                    )
                    getItemMasterInfo()
                }else {
                    Swal.fire({
                        title: data?.message || 'ทำรายการไม่สำเร็จ',
                        icon: 'warning',
                    })
                }
            } else {

                const res = await api.post(SETTING_CONFIG.requests.getItemMasters.url, body)
                const data = res.data
                if (data.status === true) {
                    navigate('/setting/item/'+ data.result.ItemNo)

                    Swal.fire(
                        'ทำรายการสำเร็จ',
                        '',
                        'success'
                    )
                }else {
                    Swal.fire({
                        title: data?.message || 'ทำรายการไม่สำเร็จ',
                        icon: 'warning',
                    })
                }

            }
        }
        if (!GroupNo) {
            setGroupError(true)
        }
        if (!CatalogNo) {
            setCatalogError(true)
        }
        if (!breedClassNo) {
            setBreedClassError(true)
        }
        if (!TypeNo) {
            setTypeNoError(true)
        }
        if (!seasonsNo) {
            setSeasonsError(true)
        }
        if (!SalePrice) {
            setSalePriceError(true)
        }
        if (GroupNo && CatalogNo && breedClassNo && TypeNo && seasonsNo && SalePrice) {
             itemMasterAdd()
        }
           
    }
    return (
        <div style={{ padding: '10px 30px' }}>
            <Page>
                <div class="container-fluid">

                    <div class=" d-flex row justify-content-between align-items-baseline">
                        <div class="col-lg-12 col-md-12 text-left ">
                            <label class="title-content mb-4">
                                {id ? 'รายละเอียดเมล็ดพันธุ์ข้าว' : 'เพิ่มรายละเอียดเมล็ดพันธุ์ข้าว'}
                            </label>


                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4 col-sm-12 " style={{ marginBottom: '10px' }}>
                            <label class="labelInput">ประเภทข้าว</label>
                            <RequireSelect value={GroupNo} onChange={setGroupNo} menu={dataItemGroups?.map((x, i) => (
                                <MenuItem key={i} value={x?.GroupNo}>{x?.GroupName}</MenuItem>
                            ))} disabled={id ? true : false} error={GroupError} setError={setGroupError} textError={'กรุณาเลือกประเภทข้าว'} />
                        </div>
                        <div class="col-md-4 col-sm-12 " style={{ marginBottom: '10px' }}>
                            <label class="labelInput">พันธุ์ข้าว</label>
                            <RequireSelect value={CatalogNo} onChange={setCatalogNo} menu={dataItemCatalogs?.map((x, i) => (
                                <MenuItem key={i} value={x?.CatalogNo}>{x?.CatalogName}</MenuItem>
                            ))} disabled={id ? true : false} error={CatalogError} setError={setCatalogError} textError={'กรุณาเลือกพันธุ์ข้าว'} />
                        </div >

                        <div class="col-lg-4 col-sm-12 " style={{ marginBottom: '10px' }}>
                            <label class="labelInput">ชั้นพันธุ์</label>
                            <RequireSelect value={breedClassNo} onChange={setBreedClassNo} menu={breedClass?.map((x, i) => (
                                <MenuItem key={i} value={x?.value}>{x?.value}</MenuItem>
                            ))} disabled={id ? true : false} error={breedClassError} setError={setBreedClassError} textError={'กรุณาเลือกชั้นพันธุ์'} />
                        </div >
                        <div class="col-lg-6 col-sm-12 " style={{ marginBottom: '10px' }}>
                            <label class="labelInput">ชนิดข้าว</label>
                            <RequireSelect value={TypeNo} onChange={setTypeNo} menu={dataItemTypes?.map((x, i) => (
                                <MenuItem key={i} value={x?.TypeName}>{x?.TypeName}</MenuItem>
                            ))} disabled={id ? true : false} error={TypeNoError} setError={setTypeNoError} textError={'กรุณาเลือกชนิดข้าว'} />
                        </div >
                        <div class="col-lg-6 col-sm-12 " style={{ marginBottom: '10px' }}>
                            <label class="labelInput">ฤดู</label>
                            <RequireSelect value={seasonsNo} onChange={setSeasonsNo} menu={seasons?.map((x, i) => (
                                <MenuItem key={i} value={x?.value}>{x?.value}</MenuItem>
                            ))} disabled={id ? true : false} error={seasonsError} setError={setSeasonsError} textError={'กรุณาเลือกฤดู'} />

                        </div >

                        <div class="col-md-8 col-sm-12 ">
                            <label class="labelInput">บาร์โค๊ด</label>
                            <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                <TextField value={Barcode} onChange={e => setBarcode(e.target.value)} variant="standard" fullWidth
                                    InputProps={{
                                        disableUnderline: true,
                                    }}
                                />
                            </Box>
                        </div>



                        <div class="col-md-4 col-sm-12 " style={{ marginBottom: '10px' }}>
                            <label class="labelInput">ราคา</label>
                            <RequireField value={SalePrice} onChange={setSalePrice} type={'number'}  error={SalePriceError} setError={setSalePriceError} textError={'กรุณากรอกราคา'} />
                        </div>
                        <div class="col-lg-12 col-sm-12">
                            <label class="labelInput">คำอธิบาย</label>
                            <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                <TextField value={Description} onChange={e => setDescription(e.target.value)} variant="standard" fullWidth multiline rows={3}
                                    InputProps={{
                                        disableUnderline: true,
                                    }}
                                />
                            </Box>
                        </div>
                        {id &&
                            <div class="row" >
                                <div class="col-lg-4 col-md-6">
                                    <label class="labelInput me-3">ผู้สร้าง</label> <label class="message-error-label">( {dayjs(detail?.CreateDate).format('DD/MM/BBBB')} )</label>
                                    <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                        <TextField disabled value={detail?.CreateId} variant="standard" fullWidth
                                            InputProps={{
                                                disableUnderline: true,
                                            }}
                                        />
                                    </Box>
                                </div>
                                <div class="col-lg-4 col-md-6">
                                    <label class="labelInput me-3">ผู้แก้ไข</label> <label class="message-error-label">( {dayjs(detail?.ModifiedDate).format('DD/MM/BBBB')} )</label>
                                    <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                        <TextField disabled value={detail?.ModifiedId} variant="standard" fullWidth
                                            InputProps={{
                                                disableUnderline: true,
                                            }}
                                        />
                                    </Box>
                                </div>
                            </div >}
                        <div class="col-md-12 mt-1  text-left ">
                            <div class="d-flex align-items-center" style={{ flexWrap: 'wrap' }}>
                                <div style={{ borderRight: '2px solid gray' }}>
                                    <RadioGroup row
                                        value={Status} onChange={e => setStatus(e.target.value)}
                                    >
                                        <FormControlLabel value="Y" control={<Radio />} label="ใช้งาน" />
                                        <FormControlLabel value="N" control={<Radio />} label="ไม่ใช้งาน" />
                                    </RadioGroup>
                                </div>

                                <div style={{ marginLeft: '15px' }}>
                                    <RadioGroup row
                                        value={Chemical} onChange={e => setChemical(e.target.value)}
                                    >
                                        <FormControlLabel disabled={id ? true : false} value="คลุกสาร" control={<Radio />} label="คลุกสารเคมี" />
                                        <FormControlLabel disabled={id ? true : false} value="ไม่คลุกสาร" control={<Radio />} label="ไม่คลุกสารเคมี" />
                                    </RadioGroup>
                                </div>

                            </div>

                        </div>


                    </div >


                    <hr class="chr" />
                    <div class="row ">

                        <div class="col-12 text-left">
                            <Button variant='outlined' onClick={() => navigate(-1)} startIcon={<FontAwesomeIcon icon={faArrowLeft} />} sx={{ width: '130px', fontSize: '14px', marginRight: '10px' }}>กลับ</Button>
                            <Button variant='contained' sx={{ width: '130px', fontSize: '14px' }} onClick={() => handleSubmit()}>{id ? 'เเก้ไข' : 'บันทึก'}</Button>

                        </div >
                    </div >
                </div >



            </Page >
        </div >
    )
}
